var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        fill: "#9BA2B6",
        height: "22",
        viewBox: "0 0 22 22",
        width: "22",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M0 11c0 6.065 4.935 11 11 11s11-4.935 11-11S17.065 0 11 0 0 4.935 0 11zm11-7.98c4.4 0 7.98 3.58 7.98 7.98a7.934 7.934 0 0 1-1.373 4.471L6.529 4.394A7.935 7.935 0 0 1 11 3.02zm4.471 14.587a7.934 7.934 0 0 1-4.47 1.373C6.6 18.98 3.02 15.4 3.02 11c0-1.656.507-3.195 1.373-4.471l11.078 11.078z",
          "fill-rule": "nonzero",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }